document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const close = document.querySelector('[data-menu-close]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  const setMenu = (open) => {
    if (!mobileNav) return;
    mobileNav.classList.toggle('is-open', open);
    mobileNav.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('menu-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  if (toggle) toggle.addEventListener('click', () => setMenu(true));
  if (close) close.addEventListener('click', () => setMenu(false));
  if (mobileNav) mobileNav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));

  document.querySelectorAll('[data-countdown]').forEach((countdown) => {
    const end = new Date(countdown.dataset.countdown).getTime();
    if (!Number.isFinite(end)) return;
    const fields = {
      days: countdown.querySelector('[data-days]'),
      hours: countdown.querySelector('[data-hours]'),
      minutes: countdown.querySelector('[data-minutes]'),
      seconds: countdown.querySelector('[data-seconds]')
    };
    const render = () => {
      const distance = Math.max(0, end - Date.now());
      const values = {
        days: Math.floor(distance / 86400000),
        hours: Math.floor((distance % 86400000) / 3600000),
        minutes: Math.floor((distance % 3600000) / 60000),
        seconds: Math.floor((distance % 60000) / 1000)
      };
      Object.keys(values).forEach((key) => { if (fields[key]) fields[key].textContent = String(values[key]).padStart(2, '0'); });
      if (distance === 0) countdown.hidden = true;
    };
    render();
    window.setInterval(render, 1000);
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const selector = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-compare-price]');
    const button = section.querySelector('[data-add-button]');
    if (!selector) return;
    selector.addEventListener('change', () => {
      const option = selector.options[selector.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      const available = option.dataset.available === 'true';
      if (button) {
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  });
});
